import { Service } from './service';

const url = {
  /*
   * V2 because the original returns a bare number[] and the shipped mobile app parses it that
   * way. That build reaches users through the app stores rather than a deploy we control, so
   * widening the old response would have switched off online indicators on every install until
   * its owner happened to update. The two endpoints answer the same question; this one also says
   * who could take a call.
   */
  GET_ONLINE_USERS: '/api/v1/vendor/websocket-rest/getOnlineUsersV2',
};

export class WebSocketService extends Service {
  getOnlineUsers() {
    return this.get(
      url.GET_ONLINE_USERS, {},
      {
        disableGlobalLoading: true,
      }
    );
  }
}
